module.exports = __webpack_public_path__ + "media/carousel_images/Imagen3-e2a01998.png";